module.exports = ({
    "CDMS802TT001": "eCRF",
    "CDMS802TT002": "ประวัติ eCRF",
    "CDMS802L001": "ชื่อการศึกษา",
    "CDMS802L002": "เวอร์ชัน",
    "CDMS802L003": "แบบฟอร์มเฉพาะ",
    "CDMS802L004": "ภาษา",
    "CDMS802OPT001": "日本語 (ภาษาญี่ปุ่น)",
    "CDMS802OPT002": "English",
    "CDMS802OPT003": "CRF พร้อมคำอธิบาย",
    "CDMS802OPT004": "แบบฟอร์ม CRF ว่าง",
    "CDMS802OPT009": "ภาษาไทย",
    "CDMS802BTN001": "ประวัติการดาวน์โหลด",
    "CDMS802BTN002": "ไปที่หน้า eCRF",
    "CDMS802H001": "ชื่อการศึกษา",
    "CDMS802H002": "เวอร์ชัน",
    "CDMS802H003": "แบบฟอร์มเฉพาะ",
    "CDMS802H004": "ภาษา",
    "CDMS802H005": "ประเภท",
    "CDMS802H006": "วันที่เริ่มต้น",
    "CDMS802H007": "วันที่สิ้นสุด",
    "CDMS802H008": "ไฟล์",
    "CDMS802H009": "สถานะ"
});
